import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Payment_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PMTTYPE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Payment Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PAYMENT_TYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Payment Type Id', columnResourceName: 'colPaymentTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    PAYMENT_TYPE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    ACTIVE_IND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Active', columnResourceName: 'colActiveInd', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var PaymentTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PMTTYPE_ID',
        id_ui: 'PAYMENT_TYPE_ID',
        name:  'PAYMENT_TYPE_NAME'},


    searchProviderFields: vUI_Payment_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Payment_Type_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var PaymentTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "PaymentTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PAYMENT_TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PAYMENT_TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PAYMENT_TYPE_ID','PAYMENT_TYPE_NAME', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PaymentTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PaymentTypeSearch: ISearch = {
    searchName: "Find Payment Type",
    renderOptions: { ui5ResourceId: "PaymentTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PaymentTypeSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PaymentTypeBO", "PaymentType", PaymentTypeSearch, "Payment Type Search")

export {PaymentTypeSearch}